import React from "react";
import { Pill } from "../../../common/DataList";

// Les deux statuts terminaux sont les seuls colorés fort : vert quand France
// Travail a reçu notre décision, rouge quand la proposition a été écartée avant
// toute instruction. Les étapes intermédiaires restent sobres. Pastilles du kit
// DataList (mêmes tons que la page Suspension / Remobilisation), pas les badges
// Bootstrap saturés du socle.
const STATUT_TONES = {
  EN_ATTENTE: "warn",
  INSCRITE_EN_EP: "info",
  DECISION_REMONTEE: "ok",
  REJETEE: "ko",
  LEVEE_A_TRAITER: "info",
  LEVEE_REPONDUE: "ok",
};

/**
 * Pastille de statut d'une proposition de sanction France Travail.
 * Le libellé affiché vient toujours de `statutLabel` (fourni par l'API).
 */
const StatutPropositionBadge = ({ statut, statutLabel }) => (
  <Pill tone={STATUT_TONES[statut] || "muted"}>{statutLabel}</Pill>
);

export default StatutPropositionBadge;
